import React from 'react';
import { endUserAppUrl, getEnv, getLmsUrl } from 'data_sources/constants';
import {
  BarChartOutlined,
  DashboardOutlined,
  DescriptionOutlined,
  SearchOutlined,
  SpeedOutlined,
  SchoolOutlined,
  SupervisorAccountOutlined,
  SwapVert,
  VerifiedUserOutlined,
  SmartToyOutlined,
} from '@mui/icons-material';

export type NavItemDef = {
  key: string;
  icon?: any;
  label?: string;
  subtitle?: string;
  divider?: boolean;
  href?: string;
  path?: string;
  children?: NavItemDef[];
  permissions?: string[];
  appPermissions?: string[];
  featureOnly?: boolean;
  sameOrg?: boolean;
  orgContext?: boolean;
  rootOnly?: boolean;
  nonRoot?: boolean;
  newWindow?: boolean;
  featurePermission?: string;
  requiresRiskPool?: boolean;
  alwaysShow?: boolean;
  visibility?: (context: {
    hasPermission: (key: string, orgId: string) => boolean;
    hasAppPermission: (key: string) => boolean;
    isFeatureEnabled: (featureId: string) => boolean;
    currentOrganizationId: string;
    hasEnabledAccreditationVersion?: boolean;
  }) => boolean;
};

const env = getEnv();

export const BASE_NAV_ITEMS: NavItemDef[] = [
  {
    key: 'searchManuals',
    icon: <SearchOutlined />,
    label: 'common.navItems.searchManuals.root',
    appPermissions: ['listIssuedManuals'],
    alwaysShow: true,
  },
  {
    key: 'dashboard',
    icon: <DashboardOutlined />,
    label: 'common.navItems.dashboard.root',
    path: 'dashboard',
    children: [],
  },
  {
    key: 'policy',
    icon: <DescriptionOutlined />,
    label: 'common.navItems.policy.root',
    path: 'policy',
    appPermissions: ['listIssuedManuals', 'listDraftManuals'],
    children: [],
  },
  {
    key: 'training',
    icon: <SchoolOutlined />,
    label: 'common.navItems.training.root',
    children: [],
    href: getLmsUrl('/assigned-learning/assignments'),
    permissions: ['trainingAdminActions'],
  },
  {
    key: 'performanceReporting',
    icon: <SpeedOutlined />,
    label: 'common.navItems.performanceReporting.root',
    path: 'performance-reporting',
    children: [],
    permissions: ['viewFieldBank'],
  },
  {
    key: 'awb',
    icon: <VerifiedUserOutlined />,
    label: 'common.navItems.awb.root',
    path: 'awb',
    children: [],
    featurePermission: 'awb',
  },
  {
    key: 'reporting',
    icon: <BarChartOutlined />,
    label: 'common.navItems.reporting.root',
    path: 'reporting',
    children: [],
  },
  {
    key: 'lexid',
    icon: <SupervisorAccountOutlined />,
    label: 'common.navItems.lexid.root',
    path: 'lexid',
    children: [],
  },
  {
    key: 'lexAi',
    icon: <SmartToyOutlined />,
    label: 'common.navItems.lexAi.root',
    path: 'lex-ai',
    children: [],
    featurePermission: 'lex-ai',
    appPermissions: ['listIssuedManuals'],
  },
  {
    key: 'endUser',
    icon: <SwapVert />,
    label: 'common.navItems.endUser.root',
    href: endUserAppUrl(),
    divider: true,
  },
];
